import myaxios from '../utils/myaxios'

export function saveCardType(data) {
    return myaxios({
        url: '/manager/sv-res',
        data,
        method: 'post'
    })
}

export function getCardTypeList() {
    return myaxios({
        url: '/manager/getCardTypeList',
    })
}

/**
 * @description 按需获取
 * @author TAO WANG
 * @date 12:58 2023/12/11 0011
 */
export function getNeedCardTypeList(data) {
    return myaxios({
        url:'/manager/needCardType/'+data
    })
}